import { WCBaseComponent } from './WCBaseComponent.js';

const template = document.createElement('template');

template.innerHTML = `
  <div class="wc-list-grid-container">
    <div class="wc-list-grid-row row">
      <div class="wc-list-grid-col col-12 col-md-6 col-lg-4 col-xxl-3 mb-3">
        <div class="wc-list-grid-card card shadow-sm border-0 border-top border-2 border-primary h-100 text-gray-700">
          <div class="wc-list-grid-card-header card-header border-0 d-flex bg-white align-items-center">
            <wc-avatar data-no-shadow data-class-bg="bg-gray-200" data-class-text="text-gray-600"">
              <i class="bi-person"></i>
            </wc-avatar>
            <p class="wc-list-grid-card-title card-title m-0 mx-2 fw-semibold">Título</p>
          </div>
          <div class="wc-list-grid-card-body card-body"></div>
          <div class="wc-list-grid-card-footer card-footer border-0 informacao bg-white"></div>
        </div>
      </div>
    </div>
  </div>
`;

export class WCListGridContainer extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListGridContainer = clone.content.querySelector('.wc-list-grid-container').cloneNode(false);
    contentNodes.forEach(node => {
      wcListGridContainer.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcListGridContainer);
  }

}

export class WCListGridRow extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListGridRow = clone.content.querySelector('.wc-list-grid-row').cloneNode(false);
    contentNodes.forEach(node => {
      wcListGridRow.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcListGridRow);
  }

}

export class WCListGridCol extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListGridCol = clone.content.querySelector('.wc-list-grid-col').cloneNode(false);
    contentNodes.forEach(node => {
      wcListGridCol.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcListGridCol);
  }

}

export class WCListGridCard extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListGridCard = clone.content.querySelector('.wc-list-grid-card').cloneNode(false);
    // let dataEmphasis = this.getAttribute('data-emphasis');
    // if (dataEmphasis !== null && dataEmphasis === 'true') {
    //   wcListGridCard.classList.remove('border-2');
    //   wcListGridCard.classList.remove('border-primary');
    //   wcListGridCard.classList.add('border-2');
    //   wcListGridCard.classList.add('border-info');
    //   // wcListGridCard.classList.add('bg-warning');
    //   // wcListGridCard.classList.add('bg-opacity-10');
    // }
    contentNodes.forEach(node => {
      wcListGridCard.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcListGridCard);
  }

}

export class WCListGridCardHeader extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListGridCardHeader = clone.content.querySelector('.wc-list-grid-card-header').cloneNode(false);
    let dataIcon = this.getAttribute('data-icon');
    if (dataIcon !== null) {
      let wcAvatar = clone.content.querySelector('wc-avatar').cloneNode(false);
      let wcIcon = document.createElement('i');
      wcIcon.classList.add(dataIcon);
      wcAvatar.innerHTML = '';
      wcAvatar.append(wcIcon);
      wcListGridCardHeader.append(wcAvatar);
    }
    contentNodes.forEach(node => {
      wcListGridCardHeader.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcListGridCardHeader);
  }

}

export class WCListGridCardBody extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListGridCardBody = clone.content.querySelector('.wc-list-grid-card-body').cloneNode(false);
    contentNodes.forEach(node => {
      wcListGridCardBody.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcListGridCardBody);
  }

}

export class WCListGridCardFooter extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListGridCardFooter = clone.content.querySelector('.wc-list-grid-card-footer').cloneNode(false);
    contentNodes.forEach(node => {
      wcListGridCardFooter.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcListGridCardFooter);
  }

}

export class WCListGridCardTitle extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListGridCardTitle = clone.content.querySelector('.wc-list-grid-card-title').cloneNode(false);
    contentNodes.forEach(node => {
      wcListGridCardTitle.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcListGridCardTitle);
  }

}